import { actions as loadingBarActions } from '../features/LoadingBar'
import { VERSIONS_SET_CLIENT, VERSIONS_SET_LAUNCHER, VERSIONS_SET_UI } from '../constants'

const VersionsMiddleware = store => next => (action) => {
    switch (action.type) {
        case VERSIONS_SET_CLIENT: {
            const result = next(action)
            store.dispatch(loadingBarActions.setClientVersion(action.payload))
            return result
        }

        case VERSIONS_SET_LAUNCHER: {
            const result = next(action)
            store.dispatch(loadingBarActions.setLauncherVersion(action.payload))
            return result
        }

        case VERSIONS_SET_UI: {
            const result = next(action)
            store.dispatch(loadingBarActions.setUiVersion(action.payload))
            return result
        }

        default:
            return next(action)
    }
}

export default VersionsMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/VersionsMiddleware.js